import { FLOOR_PLAN_EDITOR_MODES } from '../floorPlanEditorModes';

export const floorPlanDesignerConfig = {
  mode: FLOOR_PLAN_EDITOR_MODES.DESIGNER,
  initialActiveTool: 'wall',
  allowManualDraw: true,
  allowWallEdit: true,
  allowOpenings: true,
  allowRoomDetection: true,
  allow3DPreview: true,
  allowCameraPlacement: true,
  allowImportGeometry: true,
  enableBackgroundReferenceImage: false,
};
